import t from "@/lang/lang";
import { useQpmCatalogItemSetIncludeInCheckpointServiceMutation } from "@/services/backend/qpm/catalog/api/catalog-api";
import { Button } from "@/shared/components/ui/button";
import { Checkbox } from "@/shared/components/ui/checkbox";
import { Label } from "@/shared/components/ui/label";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { usePersistenceContext } from "@/shared/lib/persistence-state/context";
import { PersistenceState } from "@/shared/lib/persistence-state/persistence-state";

const tooltipContentClassName =
  "bg-background text-foreground max-w-sm border text-left text-xs [&>svg]:bg-background [&>svg]:fill-background";

export function CatalogItemQpmServiceComponent({
  catalogItemId,
  includeInCheckpointService,
}: {
  catalogItemId: string;
  includeInCheckpointService: boolean;
}) {
  const [update] = useQpmCatalogItemSetIncludeInCheckpointServiceMutation();
  const { setPersistenceState } = usePersistenceContext();

  const persist = (value: boolean) => {
    setPersistenceState(PersistenceState.SAVING);
    update({
      catalogItemId,
      includeInCheckpointService: value,
    })
      .unwrap()
      .then(() => setPersistenceState(PersistenceState.SAVED))
      .catch(() => setPersistenceState(PersistenceState.ERROR));
  };

  return (
    <div className="border-border bg-muted/30 flex items-center gap-3 rounded-md border px-3 py-2">
      <Checkbox
        className="size-5"
        checked={includeInCheckpointService}
        onCheckedChange={(value) => persist(value === true)}
      />
      <div className="flex items-center gap-2">
        <Label className="text-sm font-medium">
          {t("Als QPM Service berechnen")}
        </Label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="text-muted-foreground hover:text-foreground h-5 w-5"
                aria-label={t("Hinweis zur QPM Service Option")}
              >
                <Info className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent className={tooltipContentClassName}>
              <p>
                {t(
                  "Wenn aktiv, wird dieser Monitor in der QPM Wartung berücksichtigt. Wenn deaktiviert, wird er nicht in der QPM Service Berechnung verwendet.",
                )}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
}
